import { useRef, useState } from 'react';
import track, { useTracking } from 'react-tracking';
import loadable from '@loadable/component';

import IconChevronDown from '@assets/images/icons/legacy/chevron-down.svg';
import IconUser from '@assets/images/icons/legacy/user.svg';

import If from '@/components/If';

import { useClickOutside } from '@/hooks/useClickOutside';

import {
  Click,
  Chevron,
  User,
  AccountAccess,
  AccountAccessWrapper,
} from './styled';

const DesktopTopbarAccountDropdown = loadable(
  () =>
    import('@/components/DesktopTopbar/components/DesktopTopbarAccountDropdown')
);

const ViewedCompaniesModal = loadable(
  () =>
    import(
      '@/components/User/components/ViewedCompaniesModal/ViewedCompaniesModal'
    )
);

interface Props {
  location: string;
  maxViewCompanyReports: number;
}

export type ActiveModal = 'billing' | 'viewedCompanies' | 'none';

const DesktopTopbarAccountAccess = ({
  location,
  maxViewCompanyReports,
}: Props) => {
  const [showMenu, setShowMenu] = useState(false);
  const [activeModal, setActiveModal] = useState<ActiveModal>('none');
  const { trackEvent } = useTracking({ subject: 'primaryNavDesktopDropdown' });
  const containerRef = useRef<HTMLDivElement>(null);
  const childRef = useRef<HTMLDivElement>(null);
  useClickOutside([containerRef, childRef], () => {
    if (showMenu) {
      setShowMenu(false);
      trackEvent({ action: 'close' });
    }
  });

  return (
    <>
      <AccountAccessWrapper ref={containerRef}>
        <AccountAccess>
          <Click
            data-cy-id="account-access-show-menu"
            onClick={() => {
              trackEvent({ action: showMenu ? 'close' : 'open' });
              setShowMenu(!showMenu);
            }}
          />
          <User>
            <IconUser />
          </User>
          <Chevron>
            <IconChevronDown />
          </Chevron>
        </AccountAccess>
        {showMenu && (
          <div ref={childRef}>
            <DesktopTopbarAccountDropdown
              maxViewCompanyReports={maxViewCompanyReports}
              location={location}
              onActivateModal={setActiveModal}
            />
          </div>
        )}
      </AccountAccessWrapper>
      <If
        conditions={{
          viewedCompanies: activeModal === 'viewedCompanies',
        }}
      >
        {{
          viewedCompanies: () => (
            <ViewedCompaniesModal onClose={() => setActiveModal('none')} />
          ),
        }}
      </If>
    </>
  );
};

export default track({
  type: 'track',
  action: 'click',
  subject: 'primaryNavDesktopDropdown',
})(DesktopTopbarAccountAccess) as typeof DesktopTopbarAccountAccess;
